export const HotKeys = {
    n : [ 'TimeSheet.New' ],
    q : [ 'Question.New' ],
    a : [ 'Answer.New' ],
}
